import { TranslateLoader } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';

export class TranslateServerLoader implements TranslateLoader {
  constructor(private basePath = 'shared/options') {}

  getTranslation(lang: string): Observable<any> {
    const { readFileSync } = require('fs');
    const { join } = require('path');

    const filePath = join(
      process.cwd(),
      this.basePath,
      lang,
      'translations',
      'ang.json'
    );

    try {
      const json = JSON.parse(readFileSync(filePath, 'utf-8'));

      return of(json);
    } catch {
      console.error('[SSG translate loader] File not found', filePath);

      return of({});
    }
  }
}

